import React, { useEffect, useState, useMemo } from "react";
import axios       from "axios";
import DOMPurify   from "dompurify";
import he          from "he";
import { FiClock, FiZap } from "react-icons/fi";

import useUserLanguage from "../../hooks/useUserLanguage";
import useTranslations  from "../../hooks/useTranslations";
import "./VersionPage.css";          // 👈 yeni CSS’i ekledik

export default function VersionPage() {
  /* --- i18n --- */
  const lang = useUserLanguage();
  const { translations } = useTranslations(lang);
  const t = useMemo(( ) => (k,d)=>translations[k]||d,[translations]);

  /* --- state --- */
  const [versions,setVersions]=useState([]);
  const [loading ,setLoading ]=useState(true);

  /* --- fetch --- */
  useEffect(()=>{
    (async()=>{
      try{
        const token=localStorage.getItem("admin_token");
        const {data}=await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/versions`,
          {headers:{Authorization:`Bearer ${token}`}}
        );
        const list=(Array.isArray(data)?data:data.data??[])
                    .filter(v=>!v.deleted_at)
                    .sort((a,b)=>new Date(b.created_at)-new Date(a.created_at));
        setVersions(list);
      }catch(err){console.error("Versiyonlar alınamadı:",err);}
      finally{setLoading(false);}
    })();
  },[]);

  /* --- helpers --- */
  const safe = (raw)=>DOMPurify.sanitize(he.decode(raw??""));
  const pick = v=>v.description||v.body||v.content||v.changelog||"-";
  const fmt  = d=>new Date(d).toLocaleDateString("tr-TR",{day:"2-digit",month:"short",year:"numeric"});

  if(loading)         return <p className="text-center py-5">{t("LOADING","Yükleniyor…")}</p>;
  if(!versions.length)return <p className="text-center py-5">{t("NO_DATA","Kayıt yok")}</p>;

  const [latest,...history]=versions;

  return(
    <div className="container-lg py-4">
      <div className="card shadow-sm version-card">
        <div className="card-body">

          {/* ===== SON SÜRÜM ===== */}
          <div className="d-flex align-items-center mb-2">
            <h3 className="mb-0 me-3 text-primary fw-bold">Son Sürüm: {latest.title}</h3>

          </div>
              <small className="text-danger d-flex align-items-center gap-1 mb-4">
            <FiClock/> {fmt(latest.created_at)}
          </small>
          <div className="version-content mb-3"
               dangerouslySetInnerHTML={{__html:safe(pick(latest))}}/>



          <hr/>



          {/* ===== TARİHÇE ===== */}
          <h5 className="mb-3">{t("VERSION_HISTORY","Sürüm Geçmişi")}</h5>

          {history.map((v,i)=>(
            <div key={v.id}
              className={`mb-4 ps-3 border-start position-relative timeline-item ${
                i===history.length-1?"pb-0":""}`}>
                    
                <div style={{ display: 'flex', width: '100%' }}>
            <div style={{ width: '2%' }}>
                 <span className="position-absolute start-0 translate-middle p-2 bg-primary rounded-circle mt-2"/>
            </div>
            <div style={{ width: '98%' }}>
                <h6 className="mb-1 fw-semibold small">{v.title}</h6>
              <small className="text-danger d-flex align-items-center gap-1 mb-1">
                <FiClock/> {fmt(v.created_at)}
              </small>
              <div className="history-text"
                   dangerouslySetInnerHTML={{__html:safe(pick(v))}}/>
            </div>
            </div>            
              
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
